import { useEffect, useRef, useState } from 'react'
import FlexComponent from '../../components/FlexComponent'
import './form.css'
import { Formik } from 'formik'
import * as yup from "yup";
import { Button } from 'primereact/button'
import axios, { refreshCloudfrontCookies } from '../../utils/axios'
import { useSelector } from 'react-redux'
import { getAvailableUsers, newHomeOwnerAppSubmission, shortFormSubmission, checkAppExists } from '../../utils/urls'
import Swal from 'sweetalert2'
import { Toast } from 'primereact/toast'
import { get_form_initials } from '../../utils/urls';
import { Avatar } from 'primereact/avatar'
import ShortFormComponent from '../../components/form-new/ShortFormComponent';
import HomeOwnerAppComponent from '../../components/form-new/HomeOwnerAppComponent';
import AddressHistory from '../../components/form-new/AddressHistory';


const formSchema = yup.object().shape({
    firstName: yup.string().trim().required("required"),
    lastName: yup.string().trim().required("required"),
    language: yup.string().required("required"),
    // work_history: yup.array().min(1, 'work history is Required').required('This field is required'),
    // address_history: yup.array().min(1, 'Address is Required').required('This field is required'),
    // title: yup.string().required("required"),
    // yearly_income: yup.string().required("required"),
    // time_at_position: yup.string().required("required"),
    // total_amount_saved: yup.number().required("required"),
    // estimated_credit_score: yup.number().required("required"),
    cell_phone_number: yup.string()
        .matches(/^\(\d{3}\) \d{3}-\d{4}$/, 'Cell phone number must be in the format (xxx) xxx-xxx')
        .required('Cell phone number is required'),
    // email: yup.string().email("invalid email").required("required"),
    // do_you_have_a_cosigner: yup.string().required("required"),
    lead_source: yup.string().required("required"),
    which_homes_for_sale_region: yup.string().required("required"),
    application_pipeline: yup.string().required("required"),
    application_by: yup.string().required("required"),
    entry_type: yup.string().required("required"),
    type_of_lead: yup.string().required("required"),
    consult_scheduled: yup.string().required("required")
});



function NewHomeOwnerAppForm() {

    const [locationData, setLocationData] = useState();
    const [ghlUserId, setGhlUserId] = useState(null);
    const toast = useRef(null);
    const userId = useSelector((state) => state.user.userId);
    const [loading, setLoading] = useState(false);
    const [languageSelect, setLanguageSelect] = useState("")
    const [availableUsers, setAvailableUsers] = useState([])
    const [submissionError, setSubmissionError] = useState(null)


    const initialValues = {
        // I can definitely help. Let's get started!
        firstName: "",
        middleName: "",
        lastName: "",
        language: "",
        otherLanguage: "",

        cell_phone_number: "",
        email: "",
        // Internal Details
        lead_source: "Home Help Lead",
        other_lead_source: "",
        // name_of_lead: "",
        // cell_number_of_lead: "",
        application_pipeline: "",
        application_by: "",
        which_homes_for_sale_region: "emaoox8BVH7PhxWmz0Mg",
        entry_type: "Wants to Save",
        address_history: [],
        full_address: "",
        street_address: "",
        city: "",
        state: "",
        zip_code: "",
        // home_status : "Own",
        // status : true,
        description: "",
        type_of_lead: "",
        consult_scheduled: ""
    };

    const formatDate = (date) => {
        if (!date) return ''
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const handleClick = (event, id) => {
        event.preventDefault();
        let element = document.getElementById(id)
            ;
        if (!element && id === 'cosignerId') {
            element = document.getElementById('cosignerQuestionId')
        }
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
            const elementRect = element.getBoundingClientRect();
            const absoluteElementTop = elementRect.top + window.pageYOffset;
            window.scrollTo({ top: absoluteElementTop - 120, behavior: 'smooth' });
        }
    };

    const handleFormSubmit = async (values, onSubmitProps) => {
        try {
            setLoading(true);
            console.log('Submit requested')
            // await submitForm(values, onSubmitProps);
            const { otherLanguage, other_lead_source, full_address, street_address, city, state, zip_code, ...data } = values
            // data.form_name = "New App"
            data.language = data.language === "Other" ? otherLanguage : data.language
            data.lead_source = data.lead_source === "Other" ? other_lead_source : data.lead_source
            data.cell_phone_number = parseInt(data.cell_phone_number?.replace(/\D/g, '')) || "";
            if(full_address && (state || city)){
                data.address_history = [
                    {
                        full_address: full_address,
                        street_address: street_address,
                        city: city,
                        state: state,
                        zip_code: zip_code,
                        home_status: "Own",
                        status: true,
                    }
                ]
            }

            // setTimeout(() => {
            //     setLoading(false);
            // }, 1000);
            console.log(data)

            const checkRes = await axios.post(checkAppExists, {
                email: data.email || '',
                phone: data.cell_phone_number ? String(data.cell_phone_number) : '',
            });
            if (checkRes.data?.app_exists) {
                const proceed = await Swal.fire({
                    title: 'App Already Exists',
                    html: `<p style="margin:0">${checkRes.data.detail}</p>${checkRes.data.contact_url ? `<br/><a href="${checkRes.data.contact_url}" target="_blank" rel="noreferrer" style="color:#3085d6;font-size:0.9em">View Contact</a>` : ''}`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Proceed Anyway',
                    cancelButtonText: 'Cancel',
                });
                if (!proceed.isConfirmed) {
                    setLoading(false);
                    return;
                }
            }
            const response = await axios.post(newHomeOwnerAppSubmission, data, {
                headers: { 'Content-Type': 'application/json' },
            });
            if (response.status === 200) {
                Swal.fire({
                    position: "center",
                    icon: "success",
                    title: "Form Submitted Successfully",
                    showConfirmButton: false,
                    timer: 1500,
                });
                setLoading(false)
                onSubmitProps.resetForm();
                setSubmissionError(null)
            } else {
                const msg = response.data;
                const errText = typeof msg === 'string' ? msg : (msg?.detail || msg?.message || 'Something went wrong. Please try again');
                setLoading(false)
                setSubmissionError(errText)
            }
        } catch (error) {
            const msg = error.response?.data;
            const errText = typeof msg === 'string' ? msg : (msg?.detail || msg?.message || 'Something went wrong. Please try again');
            setLoading(false)
            setSubmissionError(errText)
        }
    };


    const getLocationList = async () => {
        if (userId) {
            try {
                const response = await axios.get(`${get_form_initials}?userId=${userId}`, {
                    headers: { 'Content-Type': 'application/json' },
                });
                if (response.status === 200) {
                    const data = response.data;
                    const mergedData = [
                        // data.default,
                        ...data.location_user_data
                    ];
                    // console.log(mergedData);
                    setLocationData(mergedData);
                    setGhlUserId(data.ghl_user_id)
                }
            } catch (error) {
                // Handle errors here
                console.error('Error fetching location list:', error);
            }
        }
    };

    const getAvailableUsersList = async () => {
        if (languageSelect) {
            try {
                const response = await axios.get(`${getAvailableUsers}?type=Live Assignment&language=${languageSelect}`, {
                    headers: { 'Content-Type': 'application/json' },
                });
                if (response.status === 200) {
                    const data = response.data;
                    console.log(data)
                    setAvailableUsers(data)
                }
            } catch (error) {
                // Handle errors here
                console.error('Error fetching location list:', error);
            }
        }
    };

    useEffect(() => {
        getLocationList();
    }, [get_form_initials, userId]);

    useEffect(() => {
        getAvailableUsersList()
    }, [languageSelect])

    function getCurrentYearlyIncome(values) {
        try {
            const findIncome = values.work_history?.find((work) => work.status)
            if (findIncome) {
                return findIncome.yearly_income
            }

        } catch (error) {
            return ''
        }
    }

    function getInitials(string) {
        let words = string?.split(' ');
        let initials = words?.map(word => word.charAt(0).toUpperCase());
        return initials?.join('');
    }

    function formatNumber(number) {
        // Convert the input to a number
        if (number) {
            const num = parseInt(number, 10);

            if (isNaN(num)) {
                throw new Error('Invalid number');
            }

            if (num >= 1000 && num < 1000000) {
                return (num / 1000).toFixed(1) + 'k';
            } else if (num >= 1000000 && num < 1000000000) {
                return (num / 1000000).toFixed(1) + 'M';
            } else if (num >= 1000000000) {
                return (num / 1000000000).toFixed(1) + 'B';
            } else {
                return num.toString();
            }
        }
    }

    return (
        <div>
            <Toast ref={toast} />
            <div className='newDesignedForm' style={{ background: "white", position: 'relative' }}>
                <FlexComponent style={{ background: 'black' }}>
                    <div style={{ color: 'white', padding: '1rem 5.2%', fontSize: '18px' }}>New Homeowner App</div>
                </FlexComponent>
                <Formik
                    onSubmit={handleFormSubmit}
                    initialValues={initialValues}
                    validationSchema={formSchema}
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleBlur,
                        handleChange,
                        setFieldValue,
                        handleSubmit,
                        isSubmitting
                        // setFieldValue,
                        // resetForm,
                    }) => (
                        <form onSubmit={handleSubmit}>
                            <FlexComponent className="formContainerDiv" justifyContent='end' alignItems='start' gap="1rem">
                                {/* <AutoComplete/> */}
                                {/* <img className="navigationClass" src={logo} style={{ width: '150px', height: '150px' }} alt="" /> */}
                                <FlexComponent
                                    className="inputFlexContainer formFlexDiv"
                                    flexDirection="column"
                                    style={{
                                        minHeight: '50vh',
                                        zIndex: '1',
                                        // background: 'white',
                                        // boxShadow: '0px 4px 10px 4px rgb(0 0 0 / 20%)',
                                        borderRadius: '15px',
                                        width: "80%"
                                    }}
                                >
                                    <HomeOwnerAppComponent setLanguageSelect={setLanguageSelect} ghlUserId={ghlUserId} locationData={locationData} values={values} errors={errors} touched={touched} handleBlur={handleBlur} handleChange={handleChange} setFieldValue={setFieldValue} toast={toast} />
                                    {/* <AddressHistory
                                        formName="Home Owner App"
                                        values={values}
                                        errors={errors}
                                        touched={touched}
                                        handleBlur={handleBlur}
                                        handleChange={handleChange}
                                        setFieldValue={setFieldValue}
                                        toast={toast}
                                    /> */}
                                    {/* {Object.keys(errors).length > 0 && <span style={{color: 'red'}}>please fill the required fields</span>} */}
                                    <FlexComponent justifyContent="center" style={{ padding: "1rem" }}>
                                        <Button type="submit" style={{ background: "black" }} label="Submit" icon="pi pi-check" loading={loading} disabled={isSubmitting} />
                                    </FlexComponent>
                                    {submissionError && <div style={{ color: "red", padding: "0 0 3rem 0" }}>{submissionError}</div>}

                                </FlexComponent>
                                <FlexComponent className="navigationClass" flexDirection="column" style={{ width: "20%", marginTop: ".2rem" }}>


                                    {availableUsers.length > 0 && <div>
                                        <h3>Available Users</h3>
                                        {availableUsers?.map((user, index) => (
                                            <FlexComponent key={index} style={{ marginTop: ".5rem" }} justifyContent="start" >
                                                <Avatar image={user.image} size="small" label={<span style={{ padding: '5px' }}>{getInitials(user?.name)}</span>} shape="circle" style={{ marginRight: '8px' }} />
                                                {user.name}
                                            </FlexComponent>
                                        ))}
                                    </div>}
                                </FlexComponent>
                            </FlexComponent>
                        </form>
                    )}
                </Formik>
            </div>
        </div>
    )
}

export default NewHomeOwnerAppForm